export const bookletsNarratifs = [
	{
		title: "Regarde la maison",
		levels: ["Niveau 1"],
		image: "regarde-la-maison.png",
		video: "01_Regarde_la_maison.mp4",
	},
	{
		title: "Je me déguise",
		levels: ["Niveau 1"],
		image: "je-me-deguise.png",
		video: "02_Je_me_deguise.mp4",
	},
	{
		title: "Nous sortons",
		levels: ["Niveau 2"],
		image: "nous-sortons.png",
		video: "03_Nous_sortons.mp4",
	},
	{
		title: "Où sont les oeufs",
		levels: ["Niveau 2", "Niveau 3"],
		image: "ou-sont-oeufs.png",
		video: "04_Ou_sont_les_oeufs.mp4",
	},
	{
		title: "Le crayon",
		levels: ["Niveau 2", "Niveau 3"],
		image: "le-crayon.png",
		video: "05_Le_crayon.mp4",
	},
	{
		title: "Éric et Jean",
		levels: ["Niveau 3"],
		image: "eric-jean.png",
		video: "06_Eric_et_Jean.mp4",
	},
	{
		title: "Le petit chien rouge",
		levels: ["Niveau 4"],
		image: "petit-chien-rouge.png",
		video: "07_Le_petit_chien_rouge.mp4",
	},
	{
		title: "Un cornet pour Banjo",
		levels: ["Niveau 5"],
		image: "cornet-pour-banjo.png",
		video: "08_Un_cornet_pour_Banjo.mp4",
	},
	{
		title: "Les formes s’amusent",
		levels: ["Niveau 6"],
		image: "formes-samusent.png",
		video: "10_Les_formes_s_amusent.mp4",
	},
	{
		title: "L’anniversaire de Banjo",
		levels: ["Niveau 7"],
		image: "anniversaire-banjo.png",
		video: "11_L_anniversaire_de_Banjo.mp4",
	},
	{
		title: "Un tigre à la clinique",
		levels: ["Niveau 8"],
		image: "tigre-clinique.png",
		video: "12_Un_tigre_a_la_clinique.mp4",
	},
	{
		title: "Zoé joue à la balle",
		levels: ["Niveau 9"],
		image: "zoe-joue-balle.png",
		video: "15_Zoe_joue_a_la_balle.mp4",
	},
	{
		title: "Les oreilles de lapin",
		levels: ["Niveau 10"],
		image: "oreilles-lapin.png",
		video: "16_Les_oreilles_de_lapin.mp4",
	},
	{
		title: "Au bord de la mer",
		levels: ["Niveau 11"],
		image: "bord-mer.png",
		video: "17_Au_bord_de_la_mer.mp4",
	},
	{
		title: "Où sont les clés&nbsp;?",
		levels: ["Niveau 12"],
		image: "ou-sont-cles.png",
		video: "19_Ou_Sont_Les_Cles.mp4",
	},
	{
		title: "Des chenilles dans la classe",
		levels: ["Niveau 13"],
		image: "chenilles-dans-classe.png",
		video: "20_Des_Chenilles_Dans_La_Classe.mp4",
	},
	{
		title: "Le faon dans la forêt",
		levels: ["Niveau 14"],
		image: "faon-dans-foret.png",
		video: "21_Le_faon_dans_la_foret.mp4",
	},
	{
		title: "Au travail, petit avion&nbsp;!",
		levels: ["Niveau 15"],
		image: "travail-petit-avion.png",
		video: "23_Au_travail_petit_avion.mp4",
	},
	{
		title: "Le paon et la grue",
		levels: ["Niveau 16"],
		image: "paon-et-grue.png",
		video: "24_Le_paon_et_la_grue.mp4",
	},
	{
		title: "Les aspirants secouristes",
		levels: ["Niveau 16"],
		image: "aspirants-secouristes.png",
		video: "25_Les_aspirants_secouristes.mp4",
	},
	{
		title: "Boucle d’Or et les trois ours",
		levels: ["Niveau 17"],
		image: "boucle-dor-trois-ours.png",
		video: "28_Boucle_Dor_et_les_Trois_Ours.mp4",
	},
	{
		title: "Chevrotain s’enfuit",
		levels: ["Niveau 18"],
		image: "chevrotain-senfuit.png",
		video: "29_Chevrotain_s_enfuit.mp4",
	},
	{
		title: "Se plier, s’étirer, sauter",
		levels: ["Niveau 19"],
		image: "plier-setirer-sauter.png",
		video: "32_Se_plier_s_etirer_sauter.mp4",
	},
	{
		title: "Mon animal à moi",
		levels: ["Niveau 20"],
		image: "mon-animal-moi.png",
		video: "33_Mon_Animal_a_Moi.mp4",
	},
	{
		title: "L’invitation surprise",
		levels: ["Niveau 21"],
		image: "invitation-surprise.png",
		video: "36_Classiques_L_invitation_surprise.mp4",
	},
	{
		title: "Incendie chez les koalas",
		levels: ["Niveau 22"],
		image: "incendie-chez-koala.png",
		video: "37_Incendie_chez_les_koalas.mp4",
	},
	{
		title: "Un choix difficile",
		levels: ["Niveau 23"],
		image: "choix-difficile.png",
		video: "40_Un_Choix_Difficile.mp4",
	},
	{
		title: "La nouvelle vie de Minh",
		levels: ["Niveau 24"],
		image: "nouvelle-vie-minh.png",
		video: "41_La_Nouvelle_vie_de_Minh.mp4",
	},
	{
		title: "De la lumière dans la mine",
		levels: ["Niveau 26"],
		image: "lumiere-dans-mine.png",
		video: "44_De_la_lumiere_dans_la_mine.mp4",
	},
	{
		title: "La ronde des papillons",
		levels: ["Niveau 26"],
		image: "ronde-papillons.png",
		video: "45_La_ronde_des_papillons.mp4",
	},
	{
		title: "Un message dans une bouteille",
		levels: ["Niveau 27"],
		image: "message-dans-bouteille.png",
		video: "46_Un_message_dans_une_Bouteille.mp4",
	},
	{
		title: "Le moment présent",
		levels: ["Niveau 28"],
		image: "moment-present.png",
		video: "47_Le_moment_Present.mp4",
	},
	{
		title: "Un si bel arbre&nbsp;!",
		levels: ["Niveau 29"],
		image: "si-bel-arbre.png",
		video: "48_Un_si_bel_arbre.mp4",
	},
]

export const bookletsInformatifs = [
	{
		title: "Je joue en sécurité",
		levels: ["Niveau 5", "Niveau 6"],
		image: "joue-en-securite.png",
		video: "09_je_joue_en_securite.mp4",
	},
	{
		title: "Soleil, vent et pluie",
		levels: ["Niveau 8", "Niveau 9"],
		image: "soleil-vent-pluie.png",
		video: "13_soleil_vent_et_pluie.mp4",
	},
	{
		title: "Mais où va l’eau&nbsp;?",
		levels: ["Niveau 8", "Niveau 9"],
		image: "ou-va-leau.png",
		video: "14_Mais_ou_va_l_eau.mp4",
	},
	{
		title: "En sécurité dans notre maison",
		levels: ["Niveau 11", "Niveau 12"],
		image: "securite-notre-maison.png",
		video: "18_En_securite_dans_notre_maison.mp4",
	},
	{
		title: "D’où viennent les aliments",
		levels: ["Niveau 14", "Niveau 15"],
		image: "ou-viennent-aliments.png",
		video: "22_Dou_viennent_les_Aliments.mp4",
	},
	{
		title: "Vivre en groupe",
		levels: ["Niveau 16", "Niveau 17"],
		image: "vivre-en-groupe.png",
		video: "26_Vivre_en_Groupe.mp4",
	},
	{
		title: "Des véhicules de secours",
		levels: ["Niveau 18", "Niveau 19"],
		image: "vehicules-secours.png",
		video: "30_Des_vehicules_de_Secours.mp4",
	},
	{
		title: "Des véhicules pour s’amuser",
		levels: ["Niveau 18", "Niveau 19"],
		image: "vehicules-samuser.png",
		video: "31_Des_vehicules_pour_s_amuser.mp4",
	},
	{
		title: "Les saison et le temps qu’il fait",
		levels: ["Niveau 20", "Niveau 21"],
		image: "saisons-temps-fait.png",
		video: "34_Les_saisons_et_le_temps_qu_Il_fait.mp4",
	},
	{
		title: "Les montagnes, les collines et les falaises",
		levels: ["Niveau 22", "Niveau 23"],
		image: "montagnes-collines-falaises.png",
		video: "38_Les_Montagnes_les_Collin.mp4",
	},
	{
		title: "Les océans, les mers et les côtes",
		levels: ["Niveau 22", "Niveau 23"],
		image: "oceans-mers-cotes.png",
		video: "39_Les__Oceans_Les_Mers_Et_Les_Cotes.mp4",
	},
	{
		title: "L’eau et le vent",
		levels: ["Niveau 24", "Niveau 25"],
		image: "eau-et-vent.png",
		video: "42_L_eau_et_le_Vent.mp4",
	},
	{
		title: "Le soleil",
		levels: ["Niveau 24", "Niveau 25"],
		image: "soleil.png",
		video: "43_Le_Soleil.mp4",
	},
]
